import numeral from 'numeral';
import * as React from 'react';

import { LandingBlogItemModel } from '../../../figma/Blog/models/LandingBlogModel';
import {
  StructuralCard,
  StructuralItemLayout,
} from '../../../figma/Card/DolCard/TextOnlyCard/StructuralCard';
import { useFromScreens } from '../../../hooks/useDeviceQuery.hook';

export interface RelatedPostCardDolVnModel extends LandingBlogItemModel {}

export interface RelatedPostCardDolVnProps {
  data: RelatedPostCardDolVnModel;
}

export const RelatedPostCardDolVn = (props: RelatedPostCardDolVnProps) => {
  const { data } = props;
  const { title, description, thumbnail, url } = data;
  const [, from552] = useFromScreens([0, 552]);
  const views = data?.views || 0;

  const imageProps = React.useMemo(() => {
    if (from552) {
      return {
        width: 160,
        ratio: 3 / 2,
      };
    }
    return {
      width: 80,
      ratio: 1,
    };
  }, [from552]);

  const structuralCardItems: StructuralItemLayout[] = React.useMemo(() => {
    return [
      {
        dataIndex: 'card-main',
        direction: 'horizontal',
        gridTemplate: {
          areas: '"card-content image"',
          columns: '1fr max-content',
          gap: [24, 24],
        },
        items: [
          {
            dataIndex: 'card-content',
            direction: 'vertical',
            gridTemplate: {
              gap: [4, 4],
              rows: views > 0 ? 'max-content max-content max-content' : 'max-content max-content',
              areas:
                views > 0
                  ? `
              "meta"
              "title"
              "description"
              `
                  : `
              "title"
              "description"`,
            },
            items: [
              views > 0 && {
                dataIndex: 'meta',
                type: 'META',
                defaultProps: {
                  metadata: [
                    {
                      id: 'NUMBER_OF_VIEW',
                      text: `${numeral(views || 0).format('0, 0a')} lượt xem`,
                    },
                  ],
                },
              },
              {
                dataIndex: 'title',
                type: 'TITLE',
                defaultProps: {
                  children: title,
                  prefetch: false,
                  url,
                },
              },
              {
                dataIndex: 'description',
                type: 'DESCRIPTION',
                defaultProps: {
                  children: description,
                },
              },
            ],
          },
          {
            dataIndex: 'image',
            type: 'IMAGE',
            defaultProps: {
              url,
              imageUrl: thumbnail.url,
              alt: thumbnail.alt || title,
              prefetch: false,
              ...imageProps,
            },
          },
        ],
      },
    ];
  }, [description, imageProps, thumbnail.alt, thumbnail.url, title, url, views]);
  return <StructuralCard items={structuralCardItems} />;
};
